"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDynamicValue = createDynamicValue;

var _DynamicValue = require("./DynamicValue");

function createDynamicValue(input, change) {
  if (input && input.isDynamic) {
    throw new Error("Can't create dynamic value from dynamic value!");
  }

  return new _DynamicValue.DynamicValue(input, change);
}
//# sourceMappingURL=createDynamicValue.js.map